import { invokeWS } from './fabric';
import { createMarkdown } from './core/markdownCore';

export const markdownService = createMarkdown({ invokeWS });
